import { render, staticRenderFns } from "./SellerInfo.vue?vue&type=template&id=13a8d8a8&"
import script from "./SellerInfo.vue?vue&type=script&lang=js&"
export * from "./SellerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports